import { useEffect } from 'react'

export const useResizeObserverFix = () => {
    useEffect(() => {
        const handleError = (e: ErrorEvent) => {
            if (
                e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
                e.message === 'ResizeObserver loop limit exceeded'
            ) {
                const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div')
                const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay')
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none')
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none')
                }
            }
        }
        window.addEventListener('error', handleError)
        return () => window.removeEventListener('error', handleError)
    }, [])
}
